/* eslint-disable @typescript-eslint/no-require-imports */
import { Platform } from 'react-native'
console.log('🚀 ~ Platform:', Platform);

// const Icon =
//   Platform.OS === 'web'
//     ? import('lucide-react')
//     : import('./Icons').then((module) => module.default)

export default import('lucide-react');